import { createSelector } from 'reselect'
import { sortBy } from '../../utils/helper'

const getActors = state => state.actors

const getNextActorsByRate = (actors) => {
    const activeTimeActorRates = actors.map((actor) => {
        // ToDo: implement more sophisticated solution including status and duration
        const actorsNextRates = [
            { ...actor },
            { ...actor, timeframe: actor.timeframe + actor.stats.rate },
            { ...actor, timeframe: actor.timeframe + (actor.stats.rate * 2) },
            { ...actor, timeframe: actor.timeframe + (actor.stats.rate * 3) },
            { ...actor, timeframe: actor.timeframe + (actor.stats.rate * 4) },
        ]
        return actorsNextRates
    })
    return activeTimeActorRates.flat()
}

const getNextActors = createSelector(
    getActors,
    actors => sortBy(Object.values(getNextActorsByRate(actors)), 'timeframe')
)

export default getNextActors
